import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AuthenticationService } from '../core/authentication.service';
import { SessionService } from '../core/session.service';
import { Countries, CountryWarehouseMapping } from '../models/country';
import { ResponseDTO } from '../models/response-dto';
import { AppSettings } from '../shared/App-Settings';

const apiUrl = AppSettings.API_BASE_URL + "api/";

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(private httpClient: HttpClient, private auth: AuthenticationService, private session: SessionService) { }

  private handleError<T>(operation = 'operation', result?: T) {
    let errorMsg = '';
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getCountries(): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'CountryCollection';

    return this.httpClient.get<any>(url, httpOptions);
  }

  getCountryList(): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'CountryCollection/getList';

    return this.httpClient.get<any>(url, httpOptions);
  }

  getFranchiseeCountryList(): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'CountryCollection/getFranchiseeCountryList';

    return this.httpClient.get<any>(url, httpOptions);
  }

  GetFranchiseeActiveCustomerCountryList(): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'CountryCollection/getFranchiseeActiveCustomerCountryList';

    return this.httpClient.get<any>(url, httpOptions);
  }

  getCountryById(countryId): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'Countries/' + countryId;

    return this.httpClient.get<any>(url, httpOptions);
  }

  updateCountry(countryModel) {
    let country = new Countries();
    country = Object.assign({}, countryModel);

    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let countryWarehouseMapping: CountryWarehouseMapping[] = [];

    countryModel.countryRates.forEach(x => {
      x.rates = x.rates.filter(y => { return (y.fromInfo != null || y.toInfo != null) && y.rate != null });
      x.rates = x.rates.filter(y => { return y.warehouseId = x.warehouseId });
      x.rates = x.rates.filter(y => { return y.countryId = countryModel.countryId });
      var countryWarehouseMappingobj = new CountryWarehouseMapping();
      countryWarehouseMappingobj.CountryId = countryModel.countryId;
      countryWarehouseMappingobj.CountryWarehouseMappingId = x.countryWarehouseMappingId;
      countryWarehouseMappingobj.OutSideDeliverySurcharges = x.outSideDeliverySurcharges;
      countryWarehouseMappingobj.oSDSurchargeWeight = x.osdSurchargeWeight
      countryWarehouseMappingobj.PackageHandlingFee = x.packageHandlingFee;
      countryWarehouseMappingobj.WarehouseId = x.warehouseId;
      countryWarehouseMapping.push(countryWarehouseMappingobj);
    });

    countryModel.countryRates = countryModel.countryRates.filter(x => { return x.rates.length > 0 });
    country.countryWarehouseMapping = countryWarehouseMapping;

    countryModel.countryRates.forEach(x => {
      x.rates.forEach(y => {
        country.countryRates.push(y);
      })
    });
    country.countryRates.splice(0, countryModel.countryRates.length)

    let url = `${apiUrl}countries/${country.countryId}`;

    return this.httpClient.put<any>(url, country, httpOptions);
  }

  getCountryListForCountryModule(currentPage: number, pageSize: number, order: string, countrySearchFilter) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'CountryCollection';
    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + " " + order;
    if (countrySearchFilter.CountryName != undefined && countrySearchFilter.CountryName != "" && countrySearchFilter.CountryName != null) url = url + '&CountryName=' + countrySearchFilter.CountryName;
    if (countrySearchFilter.IsConsoServiceAvailable != undefined && countrySearchFilter.IsConsoServiceAvailable != "" && countrySearchFilter.IsConsoServiceAvailable != null) url = url + '&IsConsoServiceAvailable=' + countrySearchFilter.IsConsoServiceAvailable;
    if (countrySearchFilter.IsDirectServiceAvailable != undefined && countrySearchFilter.IsDirectServiceAvailable != "" && countrySearchFilter.IsDirectServiceAvailable != null) url = url + '&IsDirectServiceAvailable=' + countrySearchFilter.IsDirectServiceAvailable;
    return this.httpClient.get<any>(url, httpOptions);
  }
  UpdateFlag(country) {
    let accessToken = this.auth.getAccessToken();

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}countries/${country.countryId}`;
    return this.httpClient.patch<Countries>(url, country, httpOptions);
  }
}
